<template lang="pug">
  .modal.is-active(key="modal-editar")
    .modal-background(@click="closeModalAdd()")
    .card
      header.modal-card-head.display-flex
        p.flex-1
          span(v-if="area && area.idArea") Editar Area
          span(v-else) Crear area
        span.icon.close.pointer(
            @click="$emit('close')"
          )
            i.fa.fa-close
      .card-content
        .title
          .control.margin-bottom-10
            p.margin-bottom-5 Area
            input.input.w-300(
              type="text",
              v-model="nombre"
              :disabled="isSaving"
            )
          .control.margin-bottom-10
            p.margin-bottom-5 Gerencia
              .input-container
                input.input.w-300(
                  type="text",
                  v-model="nombreGerencia"
                  :disabled="isSaving"
                  @click="mostrarBusquedaGerencia = true"
                  readonly
                )
                span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaGerencia = true")
                    i.fa.fa-search
                .erase-data(@click="borrarGerencia")
                  .icon
                    .fa.fa-times
            transition(name="fade-quick")
              .pop-over(
                  v-if="mostrarBusquedaGerencia"
                )
                gerencia(
                  @selected="seleccionarGerencia"
                  @close="mostrarBusquedaGerencia = false"
                )

      footer.card-footer
        a.card-footer-item.is-success(@click="guardar")
          span(v-if="isSaving") Guardando...
          span(v-else) Guardar
        a.card-footer-item( @click="$emit('close')")
          strong Cancelar

</template>

<script>
import { apiPost, notify } from '../util/general'
import Gerencia from './lookups/Gerencia'
export default {
  name: 'areas_editar',
  components: {
    Gerencia
  },
  props: ['area'],
  data () {
    return {
      isSaving               : false,
      mostrarModalAdjuntar   : false,
      mostrarBusquedaGerencia: false,
      id                     : '',
      nombre                 : '',
      idGerencia             : '',
      nombreGerencia         : ''
    }
  },
  mounted () {
    var vm = this
    if (vm.area) {
      vm.id             = vm.area.idArea
      vm.nombre         = vm.area.nombreArea
      vm.idGerencia     = vm.area.idGerencia
      vm.nombreGerencia = vm.area.nombreGerencia
    }
  },
  methods: {
    guardar () {
      var vm = this
      if (vm.isSaving) return;
      vm.isSaving = true

      var obj = {
        id        : vm.id,
        area      : vm.nombre,
        idGerencia: vm.idGerencia
      }

      apiPost(vm, '/area', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    },
    borrarGerencia () {
      var vm = this
      vm.idGerencia = ''
      vm.nombreGerencia = ''
    },
    seleccionarGerencia (o) {
      var vm = this
      vm.idGerencia = o.id
      vm.nombreGerencia = o.nombre
      vm.mostrarBusquedaGerencia = false
    },
    emitClose () {
      this.$emit('close')
    },
    closeModalAdd () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .input-container
    display flex
    align-items center
    .input
      flex 1
      width 100px
    .erase-data
      cursor pointer
      margin-left 5px
  .pointer
    cursor pointer
  .solicitud-vacaciones
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .contenedor-datos
    display flex
    justify-content center
    >*
      transition: all 0.5s;

    .contenedor-transaccion
      .fechas
        display flex
        justify-content center
        .control
          padding 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    max-width: 426px;

    strong
      color #209cee

    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .codigo-empleado
    position relative
    .control
      text-align center
      .input
        width 100px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0
      left: 42px;
</style>



// WEBPACK FOOTER //
// Component_Gestion_Areas_Editar.vue?043161b8